import cx from '@ui-components-3/ui/lib/utils/classNames'
import { ReactNode } from 'react'

type PageProps = {
  className?: string
  children: ReactNode
  style?: any
  id?: string
}

const Page = ({ className, ...props }: PageProps) => (
  <div className={cx('relative flex flex-auto overflow-x-hidden overflow-y-scroll', className)} {...props} />
)

type PageContentProps = {
  className?: string
  children: ReactNode
  style?: any
}

export const PageContent = ({ className, ...props }: PageContentProps) => (
  <div className={cx('relative flex w-full flex-auto flex-col bg-[#f9fafc]', className)} {...props} />
)

type PageBodyProps = {
  className?: string
  children: ReactNode
  style?: any
}

export const PageBody = ({ className, ...props }: PageBodyProps) => (
  <div className={cx('flex h-full w-full flex-auto flex-col items-center bg-[#fafafa]', className)} {...props} />
)

type PageTitleProps = {
  className?: string
  children: ReactNode
  style?: any
}

export const PageTitle = ({ className, ...props }: PageTitleProps) => (
  <div
    className={cx('mb-[24px] mt-[80px] text-center text-[48px] leading-[40px] text-[#3c3c3c]', className)}
    {...props}
  />
)

export default Page
